// extracted by mini-css-extract-plugin
export default {"socialButtonsText":"G15d5d5","offerWrapper":"G729ef8","offerTitle":"G06d72a","offer":"G516d61","offerDescription":"Gf24ae4","rafLink":"Ge07a0e"};